import React from "react";
import Masonry from "react-masonry-css";
import php from "../assets/certificate/Php.jpeg";
import python from "../assets/certificate/python.png";
import UdemyPython from "../assets/certificate/UdemyPython.jpg";
import Docker from "../assets/certificate/Docker.jpg";
import UdemyReact from "../assets/certificate/UdemyReact.jpeg";
import UdemyNextjs from "../assets/certificate/UdemyNextjs.jpg";
import UdemySvelte from "../assets/certificate/UdemySvelte.jpg";
import UdemyGit from "../assets/certificate/UdemyGit.jpg";
import UdemyPyBeg from "../assets/certificate/UdemyPyBeg.jpg";

const cert = [
  { id: 7, src: UdemySvelte },
  { id: 1, src: php },
  { id: 2, src: UdemyPython },
  { id: 3, src: UdemyNextjs },
  { id: 4, src: python },
  { id: 5, src: Docker },
  { id: 6, src: UdemyReact },

  { id: 8, src: UdemyGit },
  { id: 9, src: UdemyPyBeg },
];

const breakpointColumnsObj = {
  default: 3,
  1024: 2,
  768: 1,
};

const Certificate = () => {
  return (
    <div
      name="certificate"
      className="bg-gradient-to-b from-black to-gray-800 w-full text-white py-16"
    >
      <div className="max-w-screen-lg px-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8 text-center">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Certificates
          </p>
          <p className="py-6 text-gray-400">Here are some of my achievements</p>
        </div>

        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {cert.map((port) => (
            <div
              key={port.id}
              className="bg-gray-900 rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-transform duration-300 hover:scale-[1.03]"
            >
              <img
                src={port.src}
                alt="certificate"
                className="w-full h-auto object-cover"
              />
            </div>
          ))}
        </Masonry>
      </div>
    </div>
  );
};

export default Certificate;
